<template>
  <div>
    <donut-page-title :title="title" :subtitle="subtitle" />
    <donut-tabs :tabs="tabs" :initial-tab="initialTab" class="m-tx4" />
  </div>
</template>

<script setup>
  import { computed, inject } from 'vue';
  import { useStore } from 'vuex';
  import { capitalize } from 'lodash';

  const props = defineProps({
    initialTabValue: { type: String, default: 'events' },
  });
  const $i18n = inject('$i18n');
  const { state } = useStore();

  const pointsNoun = $i18n.t('shoutouts.point', { count: 2 });

  const showMilestones = computed(() => state.bonusMilestoneConfigs.showMilestones);
  const title = showMilestones.value ? `Milestone ${capitalize(pointsNoun)}` : `Bonus ${capitalize(pointsNoun)}`;
  const subtitle = showMilestones.value
    ? `Employees can accumulate recognition ${pointsNoun} by achieving key milestones that boost company culture.`
    : `Employees can accumulate recognition ${pointsNoun} by participating in activities or achieving key milestones that boost company culture.`;

  const tabs = computed(() => {
    if (showMilestones.value) {
      return [
        { title: 'Annual Events', value: 'milestones', link: '/bonus/milestones' },
        { title: 'Bonus Events', value: 'events', link: '/bonus/event_templates' },
        { title: 'Upcoming Events', value: 'upcoming', link: '/bonus/milestones/upcoming' },
        { title: 'Event History', value: 'history', link: '/bonus/events/history' },
      ];
    }
    return [
      { title: 'Bonus Events', value: 'events', link: '/bonus/event_templates' },
      { title: 'Bonus History', value: 'history', link: '/bonus/events/history' },
    ];
  });
  const initialTab = computed(() => tabs.value.find(tab => tab.value === props.initialTabValue));
</script>
